export const VALIDATIONS_ERROR = {
  REQUIRED: 'Campo requerido',
  INVALID_FORMAT: 'Formato inválido',
};
